module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"general":"General","user":"Users","tokens":"Tokens","providerSR":"Report Providers","socialmedia":"Social Media","webhooks":"Webhooks"},"fr":{"general":"Général","user":"Utilisateurs","tokens":"Tokens","providerSR":"Report Providers","socialmedia":"Réseaux sociaux","webhooks":"Webhooks"}}')
  delete Component.options._Ctor
}
